<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList">
      <template slot="self-config">
        <el-form-item label="一键修改字段值" prop="field_id">
          <div v-for="(item, index) in form.modify_list">
            <el-select v-model="item.field_id" filterable placeholder="字段名" class="fl w-150 m-r-10">
              <el-option v-for="option in inputList" :label="option.default.name + '(' + option.default.title + ')'" :value="option.default.field_id"></el-option>
            </el-select>
            <span>修改为</span>
            <el-select v-model="item.type" placeholder="请选择类型">
              <el-option label="常量" :value="10"></el-option>
              <el-option label="时间变量" :value="20"></el-option>
            </el-select>
            <el-input class="w-200 h-40" v-model="item.value"></el-input>
            <el-button type="danger" size="small" @click="deleteModify(index)" v-show="showDelete">删除</el-button>
          </div>
          <div class="form-tips lh-20" style="width:50%">时间变量说明：Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后，不填即当前时间</div>
          <el-button type="primary" @click="addModify">添加</el-button>
        </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          has_condition: 0, // 是否有条件限制
          condition: {    // 可见条件
            visible: [],  // 可见
            invisible: [],  // 不可见
            forbiden: []  // 禁用
          },
          modify_list: []
        },
        modifyModel: {
          field_id: '',
          value: '',
          type: ''
        },
        deleteShow: false,  // 删除分组提示显示标识
        inputList: []  // 控件数组
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.has_condition = res.data.config.has_condition
              this.form.modify_list = res.data.config.modify_list
              if (res.data.config.condition) {
                this.form.condition = res.data.config.condition
              }
              if (!this.form.modify_list || !this.form.modify_list.length) {
                this.form.modify_list = []
              }
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
          }
        })
      },
      addModify() {
        this.form.modify_list.push(_.cloneDeep(this.modifyModel))
      },
      deleteModify(index) {
        this.form.modify_list.splice(index, 1)
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      },
      showDelete() {
        return this.form.modify_list && this.form.modify_list.length > 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// statusConfig.vue?c697a590